import { ValidatorResult } from './validator';
import { Observable } from 'rxjs';
import { DxFormGroup } from '../form-group';
import { ASYNC_VALIDATOR_KEY } from './metadata-keys';
import { addToMetadata } from '@digitaix/helpers';
import { Without } from '@digitaix/types';

export function AsyncValidator<T>(
  controlId: keyof Without<T, keyof DxFormGroup<any>>,
  controlPaths: string[] = [],
  validatorErrorTemplate?: string
) {
  return function(
    target: Partial<Without<T, keyof DxFormGroup<any>>>,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<
      ValidatorResult | Observable<ValidatorResult>
    >
  ) {
    addToMetadata(
      ASYNC_VALIDATOR_KEY,
      {
        controlId,
        controlPaths: [controlId, ...controlPaths],
        validatorErrorTemplate,
        propertyKey
      },
      target
    );
  };
}
